const AccessRoles = {
  NETWORK_MANAGEMENT: 'network_management',
  PUBLISHER_MANAGEMENT: 'publisher_management',
  SITE_MANAGEMENT: 'site_management',
  PLACEMENT_MANAGEMENT: 'placement_management',

  AD_QUALITY_RULE_MANAGEMENT: 'ad_quality_rule_management',
  SITE_CAMPAIGN_MANAGEMENT: 'site_campaign_management',
  PMP_CAMPAIGN_MANAGEMENT: 'pmp_campaign_management',
  RTB_CAMPAIGN_MANAGEMENT: 'rtb_campaign_management',
  AD_TAG_CAMPAIGN_MANAGEMENT: 'ad_tag_campaign_management',

  MACRO_MAP_MANAGEMENT: 'macro_map_management',
  AD_SIZE_MANAGEMENT: 'ad_size_management',
  JS_FUNCTION_MANAGEMENT: 'js_function_management',
  CREATIVE_TEMPLATE_MANAGEMENT: 'creative_template_management',
  SERVER_FILE_MANAGEMENT: 'server_file_management',
  BIDDER_MANAGEMENT: 'bidder_management',
  BIDDER_ACCOUNT_MANAGEMENT: 'bidder_account_management',

  MONITOR_MANAGEMENT: 'monitor_management',
  REPORT_PLACEMENT_MANAGEMENT: 'report_placement_management',
  REPORT_SITE_MANAGEMENT: 'report_site_management',

  USER_MANAGEMENT: 'user_management',
  TEAM_MANAGEMENT: 'team_management',
  PROPERTY_MANAGEMENT: 'property_management',
  MACRO_MAP_KEY_MANAGEMENT: 'macro_map_key_management',
  DOCUMENTATION_MANAGEMENT: 'documentation_management'
};

export default AccessRoles;



// WEBPACK FOOTER //
// ./src/views/StaticData/Roles/Access.tsx